import "./css/style.scss";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import NotFound from "./Pages/NotFound.jsx";
import PrivacyPolicy from "./Pages/PrivacyPolicy.jsx";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

const root = ReactDOM.createRoot(document.querySelector("#root"));

root.render(<RouterProvider router={router} />);
